import {Device} from "./types";

export class AppConstants {
    static companyName = "KareKimlik";
    static appName = "PiLoT";
    // static url = "http://guard.local:3000";
    static url = process.env.REACT_APP_API_URL;
    public static heartBeatInterval: number =
        process.env.REACT_APP_HEART_BEAT_INTERVAL ? Number(process.env.REACT_APP_HEART_BEAT_INTERVAL) : 60000;
    public static refreshInterval: number =
        process.env.REACT_APP_REFRESH_INTERVAL ? Number(process.env.REACT_APP_REFRESH_INTERVAL) : 3600000;

    // public static timerInterval: number = 10000; // miliseconds.    

    public static getTimerInterval(periodSeconds: number): number {
        if (periodSeconds <= 120) return 1000;
        if (periodSeconds <= 300) return 5000; // 5 saniye
        if (periodSeconds <= 600) return 10000; // 10 saniye
        if (periodSeconds <= 3600) return 60000; //1 dk
        // todo: 5 dk yenileme oldugu için 10 dakilak periyodan hesaplama hiç çalışmıyordu.
        return 20000; // 
        // return 600000; // 10 dk
    }

}


// export enum ETogglePinStates {
//     OFF,
//     ON,
//     MANUEL,
//     AUTO,
//     CLOSED,
//     OPEN,
//     RESET
// }



export enum ERelayStatexxx {
    stopped, running, manuel

    // static readonly Stopped = new ERelayState("stopped", "red");
    // static readonly Running = new ERelayState("running", "green");
    // static readonly Manuel = new ERelayState("manuel", "orange");

    // private constructor(public readonly name: string, public readonly color: string) { }
}



export class ERelayState {
    static readonly Stopped = new ERelayState(0, "stopped", "grey");
    static readonly Running = new ERelayState(1, "running", "red");
    static readonly Manuel = new ERelayState(2, "running", "orange");

    private constructor(
        public readonly index: number,
        public readonly name: string,
        public readonly color: string
    ) {}

    // Tüm enum değerlerini bir dizi olarak döndürür
    static values(): ERelayState[] {
        return [ERelayState.Stopped, ERelayState.Running, ERelayState.Manuel];
    }

    // Index ile erişim fonksiyonu
    static fromIndex(index: number): ERelayState | undefined {
        return this.values().find(state => state.index === index);
    }

    static getColor(index: number): string {
        let result = this.values().find(state => state.index === index)?.color;
        if (!result) result = 'blue';

        return result;
    }


}

export enum ERelayCommand {
    NA,
    PULSE,
    ON,
    OFF,
    TOGGLE,
    LOOP,
    STATUS
}

// ESP command protocol. Keep these numeric values aligned with the device firmware.
export enum EPinCommand {
    NA = 0,
    PULSE = 1,
    ON = 2,
    OFF = 3,
    TOGGLE = 4,
    LOOP = 5,
    STATUS = 6
}

export const relayCommand = (device: Device): ERelayCommand => {
    if (device.pinCommand === EPinCommand.LOOP) {
        return ERelayCommand.LOOP;
    }
    if (device.pinCommand === EPinCommand.ON && device.status === 1 && !device.loop) {
        return ERelayCommand.ON;
    }
    return ERelayCommand.PULSE;

};


export const formatTime = (seconds: number): string => {
    const days = Math.floor(seconds / 86400);
    const h = String(Math.floor((seconds % 86400) / 3600)).padStart(2, "0");
    const m = String(Math.floor((seconds % 3600) / 60)).padStart(2, "0");
    const s = String(seconds % 60).padStart(2, "0");
    if (days > 0) {
        return `${days}, ${h}:${m}:${s}`;
    }
    return `${h}:${m}:${s}`;

};

export const formatDuration = (seconds: number): string => {
    const days = Math.floor(seconds / 86400);
    const h = Math.floor((seconds % 86400) / 3600);
    const m = Math.floor((seconds % 3600) / 60);
    const s = seconds % 60;
    let result = "";
    if (days > 0) result += days + "d";
    if (h > 0) result += " " + h + "h";
    if (m > 0) result += " " + m + "m";
    if (s > 0) result += " " + s + "s";
    return result;

};

